import React, { useState, useEffect } from "react";
import { API_URL } from "../../../../constants";
import { Table } from "react-bootstrap";
import Select from "react-select";
import moment from "moment";
import {
  GetServiceCaller,
  PostServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { useDispatch } from "react-redux";
import { FaSpinner } from "react-icons/fa";
import { useLocation, useParams } from "react-router-dom";
import { AlertCircle } from "lucide-react";

const PerformanceEvaluations = () => {
  const dispatch = useDispatch();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const cycleidURL = queryParams.get("cycleid");

  useEffect(() => {
    fetchOpts();
    dispatch(updateNavbarHeading("Performance Evaluation"));
  }, []);

  const [cycle_Id, setcycle_Id] = useState(null);
  const [employeeId, setEmployeeId] = useState(null);
  const [appraisalMasterID, setAppraisalMasterID] = useState(null);
  const [formData, setFormData] = useState({});
  const [formTemplate, setFormTemplate] = useState([]);
  const [employeData, setEmployeData] = useState(null);
  const [error, setError] = useState("");
  const [appraisalCycleList, setAppraisalCycleList] = useState([]);
  const [empList, setEmpList] = useState([]);
  const [defaultEmployee, setDefaultEmployee] = useState(null);
  const [appraisalCycleError, setAppraisalCycleError] = useState("");
  const [formVisible, setFormVisible] = useState(false);
  const [formCount, setFormCount] = useState(1);
  const [reviewerFormData, setReviewerFormData] = useState({});
  const [userSessionData, setUserSessionData] = useState(
    JSON.parse(localStorage.getItem("user"))
  );
  const [loading, setLoading] = useState(false);
  const [loadingDraft, setLoadingDraft] = useState(false);
  const [pageLaoding, setPageLaoding] = useState(false);
  const [selectedCycle, setSelectedCycle] = useState(null);
  const [errorMessages, setErrorMessages] = useState({});

  useEffect(() => {
    if (cycleidURL) {
      setcycle_Id(cycleidURL);
      setTimeout(() => {
        fetchFormTemplate(cycleidURL);
      }, 2000);
    }
  }, [cycleidURL]);

  const fetchOpts = async () => {
    try {
      const queryParams = new URLSearchParams({
        cycleId: null ?? "",
      }).toString();
      const response = await GetServiceCaller(
        `${API_URL}performance-evaluation/create?${queryParams}`
      );

      if (response?.status == 200) {
        const cycleList = response?.data?.data?.cycleList?.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setAppraisalCycleList(cycleList);
        setcycle_Id(
          cycleidURL == null || cycleidURL == undefined
            ? cycleList?.[0].value
            : cycleidURL
        );
        setSelectedCycle(cycleList?.[0]);

        const empListData = Object.values(
          response?.data?.data?.team_list
        )?.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setEmpList(empListData);
        setDefaultEmployee(empListData[0]?.value);

        if (userSessionData?.DefaultContactID) {
          if (empListData) {
            const defaultEmp = empListData.find(
              (emp) => emp.value === userSessionData?.DefaultContactID
            );
            setEmployeeId(defaultEmp?.value);
          } else {
            setEmployeeId(userSessionData?.DefaultContactID);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleCycleChange = (selectedOption) => {
    setcycle_Id(selectedOption ? selectedOption.value : null);
    setSelectedCycle(selectedOption);
    if (selectedOption?.value) {
      setAppraisalCycleError("");
    }
  };

  const handleEmployeeChange = (selectedOption) => {
    setDefaultEmployee(selectedOption?.value);
    setEmployeeId(selectedOption?.value);
  };

  const [templateAPIStatus, setTemplateAPIStatus] = useState("");
  const [templateMessage, setTemplateMessage] = useState("");

  const fetchFormTemplate = async (cycleidURL) => {
    if (!cycle_Id && !cycleidURL) {
      setAppraisalCycleError("Appraisal Cycle is required");
      return;
    } else {
      setAppraisalCycleError("");
    }

    setFormData({});
    setReviewerFormData({});
    setEmployeData(null);
    setFormTemplate([]);
    setFormVisible(false);

    const dataForm = {
      cycle_id: cycle_Id ?? cycleidURL,
      employee_id: defaultEmployee,
    };
    setPageLaoding(true);
    try {
      const response = await PostFormServiceCaller(
        `${API_URL}fetch-emp-performance-evaluation-info`,
        dataForm
      );
      setTemplateAPIStatus(response?.status);
      if (response?.status == 201) {
        setTemplateMessage(response?.data?.message);
      }
      if (response?.data) {
        setPageLaoding(false);

        const appraisalTemplateID =
          response?.data?.data?.performanceEvaluationHeader
            ?.AppraisalTemplateMasterID;
        setAppraisalMasterID(appraisalTemplateID);

        const cycleDetails = response?.data?.data?.performanceEvaluationLines;
        setFormTemplate(cycleDetails || []);

        const initialFormData = {};
        const initialReviewerFormData = {};

        cycleDetails.forEach((question) => {
          if (question.QuestionType_202 === 1342) {
            initialFormData[question.QuestionMasterID] = {
              answer: question.EmployeeAnswer || "",
              EmployeeRating: question.EmployeeRating || null,
            };
          } else if (question.QuestionType_202 === 1343) {
            const selectedOption = getOptionKeyFromAnswer(
              question,
              question.EmployeeAnswer
            );
            initialFormData[question.QuestionMasterID] = {
              EmployeeRating: question.EmployeeRating || null,
              selectedOption: selectedOption,
              selectedOptionLabel: question.EmployeeAnswer
                ? [question.EmployeeAnswer]
                : [],
            };
          } else if (question.QuestionType_202 === 1347) {
            const selectedLabels = question.EmployeeAnswer
              ? question.EmployeeAnswer.split(",").map((label) => label.trim())
              : [];

            const selectedOptions = [];
            if (selectedLabels.includes(question.Option1))
              selectedOptions.push("Option1");
            if (selectedLabels.includes(question.Option2))
              selectedOptions.push("Option2");
            if (selectedLabels.includes(question.Option3))
              selectedOptions.push("Option3");
            if (selectedLabels.includes(question.Option4))
              selectedOptions.push("Option4");

            initialFormData[question.QuestionMasterID] = {
              selectedOptions: selectedOptions,
              selectedOptionLabel: selectedLabels,
              EmployeeRating: parseFloat(question.EmployeeRating) || null,
            };
          }

          initialReviewerFormData[question.QuestionMasterID] = {
            reviewerans: question.ReviewerAnswer || "",
            ReviewerRating: question.ReviewerRating || 0,
          };
        });

        setReviewerFormData(initialReviewerFormData);
        setFormData(initialFormData);
        setFormVisible(true);

        const empDetails =
          response?.data?.data?.employeeDetails?.[0] ||
          response?.data?.data?.employeeDetails;
        setEmployeData(empDetails);

        const user = JSON.parse(localStorage.getItem("user"));
        const defaultContactID = user?.DefaultContactID;
        if (defaultContactID) {
          const currentContactID = empDetails?.ContactID;
          if (currentContactID) {
            if (currentContactID === defaultContactID) {
              setFormCount(1);
            } else {
              setFormCount(2);
            }
          }
        }
      } else {
        console.error("No data found in response");
      }
    } catch (error) {
      console.error("Error fetching Form Template:", error);
    } finally {
      setPageLaoding(false);
    }
  };

  const getOptionKeyFromAnswer = (question, answer) => {
    if (answer === question.Option1) return "Option1";
    if (answer === question.Option2) return "Option2";
    if (answer === question.Option3) return "Option3";
    if (answer === question.Option4) return "Option4";
    return "";
  };

  const handleTextChange = (e, questionId, question) => {
    const newText = e.target.value;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [questionId]: { ...prevFormData[questionId], answer: newText },
    }));

    setErrorMessages((prevErrors) => {
      const newErrors = { ...prevErrors };
      const minChars = question?.QuestionMinCharacter || 10;
      const maxChars = question?.QuestionMaxCharacter || 500;
      const textLength = newText.trim().length;

      if (textLength === 0) {
        newErrors[questionId] = "Answer is required.";
      } else if (textLength < minChars) {
        newErrors[questionId] = `Answer must be at least ${minChars} characters long.`;
      } else if (textLength > maxChars) {
        newErrors[questionId] = `Answer cannot exceed ${maxChars} characters.`;
      } else {
        delete newErrors[questionId];
      }

      return newErrors;
    });
  };

  const handleTextRatingChange = (e, questionId, question) => {
    const newRating = e.target.value;

    const numericValue = parseFloat(newRating);
    const maxWeight = parseFloat(question?.Weightage) || 10.0;
    const isValidRating =
      !isNaN(numericValue) && numericValue >= 0 && numericValue <= maxWeight;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [questionId]: {
        ...prevFormData[questionId],
        EmployeeRating: isValidRating ? numericValue.toString() : null,
      },
    }));

    setErrorMessages((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (newRating.trim() === "") {
        newErrors[`${questionId}_rating`] = "Rating is required.";
      } else if (!isValidRating) {
        newErrors[
          `${questionId}_rating`
        ] = `Please enter a valid number between 0 and ${
          question?.Weightage || 10
        }`;
      } else {
        delete newErrors[`${questionId}_rating`];
      }

      return newErrors;
    });
  };

  const handleRadioChange = (e, questionId, optionKey, item) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [questionId]: {
        ...prevFormData[questionId],
        EmployeeRating: item.weightage,
        selectedOption: optionKey,
        selectedOptionLabel: [item.option],
      },
    }));

    setErrorMessages((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[questionId];
      return newErrors;
    });
  };

  // --- FIXED CHECKBOX LOGIC START ---
  const handleCheckboxChange = (e, questionId, optionKey, optionLabel, optionWeightage, question) => {
    const { checked } = e.target;

    setFormData((prevFormData) => {
      const currentQuestionData = prevFormData[questionId] || {};
      let selectedOptions = Array.isArray(currentQuestionData.selectedOptions)
        ? [...currentQuestionData.selectedOptions]
        : [];
      let selectedOptionLabel = Array.isArray(currentQuestionData.selectedOptionLabel)
        ? [...currentQuestionData.selectedOptionLabel]
        : [];

      if (checked) {
        if (!selectedOptions.includes(optionKey)) {
          selectedOptions.push(optionKey);
          selectedOptionLabel.push(optionLabel);
        }
      } else {
        selectedOptions = selectedOptions.filter(opt => opt !== optionKey);
        selectedOptionLabel = selectedOptionLabel.filter(lbl => lbl !== optionLabel);
      }

      // Re-calculate the total rating from the array of selected options
      const totalRating = selectedOptions.reduce((acc, optKey) => {
        const weightField = `OptionWeightage${optKey.replace("Option", "")}`;
        return acc + (parseFloat(question[weightField]) || 0);
      }, 0);

      return {
        ...prevFormData,
        [questionId]: {
          ...currentQuestionData,
          selectedOptions,
          selectedOptionLabel,
          EmployeeRating: totalRating.toFixed(2), 
        },
      };
    });

    setErrorMessages((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (checked) {
        delete newErrors[questionId];
      }
      return newErrors;
    });
  };
  // --- FIXED CHECKBOX LOGIC END ---

  const handleEmployeeSubmit = async (e, isDraft = false) => {
    e.preventDefault();

    let errors = {};

    if (!isDraft) {
      formTemplate.forEach((question) => {
        const response = formData[question.QuestionMasterID];
        const questionId = question.QuestionMasterID;

        if (question.QuestionType_202 === 1342) {
          if (!response?.answer?.trim()) {
            errors[questionId] = "Answer is required.";
          } else {
            const minChars = question?.QuestionMinCharacter || 10;
            const maxChars = question?.QuestionMaxCharacter;
            const answerLength = response.answer.trim().length;

            if (answerLength < minChars) {
              errors[questionId] = `Minimum ${minChars} characters required.`;
            } else if (maxChars && answerLength > maxChars) {
              errors[questionId] = `Maximum ${maxChars} characters allowed.`;
            }
          }

          if (!response?.EmployeeRating) {
            errors[`${questionId}_rating`] = "Rating is required.";
          } else {
            const rating = parseFloat(response.EmployeeRating);
            const maxWeight = parseFloat(question?.Weightage) || 10.0;

            if (isNaN(rating) || rating < 0 || rating > maxWeight) {
              errors[
                `${questionId}_rating`
              ] = `Enter a value between 0 and ${maxWeight.toFixed(2)}.`;
            }
          }
        } else if (question.QuestionType_202 === 1343) {
          if (!response?.selectedOption) {
            errors[questionId] = "Please select an option.";
          }
        } else if (question.QuestionType_202 === 1347) {
          if (!response?.selectedOptionLabel?.length) {
            errors[questionId] = "Please select at least one option.";
          }
        }
      });

      if (Object.keys(errors).length > 0) {
        setErrorMessages(errors);
        toast.error("Please fix the validation errors before submitting.");
        return;
      }
    }

    setErrorMessages({});

    const formattedData = formTemplate.map((question) => {
      const response = formData[question.QuestionMasterID];
      let employeeAnswer = "";
      let employeeRating = null;

      if (question.QuestionType_202 === 1342) {
        employeeAnswer = response?.answer || "";
        employeeRating = response?.EmployeeRating || null;
      } else if (question.QuestionType_202 === 1343) {
        if (response?.selectedOption === "Option1") {
          employeeAnswer = question.Option1;
          employeeRating = question.OptionWeightage1;
        } else if (response?.selectedOption === "Option2") {
          employeeAnswer = question.Option2;
          employeeRating = question.OptionWeightage2;
        } else if (response?.selectedOption === "Option3") {
          employeeAnswer = question.Option3;
          employeeRating = question.OptionWeightage3;
        } else if (response?.selectedOption === "Option4") {
          employeeAnswer = question.Option4;
          employeeRating = question.OptionWeightage4;
        }
      } else if (question.QuestionType_202 === 1347) {
        employeeAnswer = response?.selectedOptionLabel?.join(", ") || "";
        employeeRating = response?.EmployeeRating || null;
      }

      return {
        QuestionMasterID: question.QuestionMasterID,
        QuestionType_202: question.QuestionType_202,
        EmployeeAnswer: employeeAnswer,
        EmployeeRating: employeeRating,
      };
    });

    const payload = {
      AppraisalCycleID: cycle_Id || null,
      EmployeeID:
        defaultEmployee ||
        employeeId ||
        userSessionData?.DefaultContactID ||
        null,
      AppraisalTemplateMasterID: appraisalMasterID,
      IsSaveAsDraft: isDraft ? "1" : "0",
      Lines: formattedData,
    };

    if (isDraft) {
      setLoadingDraft(true);
    } else {
      setLoading(true);
    }

    try {
      const response = await PostServiceCaller(
        `${API_URL}add-employee-feedback`,
        payload,
        "post"
      );

      if (response.status === 200) {
        if (isDraft) {
          toast.success("Saved Successfully!");
        } else {
          toast.success("Form submitted successfully!");
        }
        setTimeout(() => {
          setFormCount(0);
          setEmployeData(null);
        }, 2000);
      }
    } catch (error) {
      console.error("There was an error submitting the form data!", error);
      toast.error("Error submitting form data.");
    } finally {
      setLoading(false);
      setLoadingDraft(false);
    }
  };

  const handleCancel = () => {
    window.location.reload();
    setFormVisible(false);
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <div className="col-md-3">
              <div className="col-auto">
                <label>
                  <b>Appraisal Cycle</b>
                  <span className="required">*</span>
                </label>
              </div>
              <div className="col-auto">
                <Select
                  value={appraisalCycleList?.find((ele) => ele.value == cycle_Id)}
                  options={appraisalCycleList}
                  onChange={handleCycleChange}
                />
              </div>
              {appraisalCycleError && (
                <div className="error-message" style={{ color: "red" }}>
                  {appraisalCycleError}
                </div>
              )}
            </div>
            {empList.length != 0 ? (
              <div className="col-md-3">
                <div className="col-auto">
                  <label>
                    <b>Employee</b>
                  </label>
                </div>
                <div className="col-auto">
                  <Select
                    options={empList}
                    value={empList?.find((ele) => ele?.value === defaultEmployee)}
                    onChange={handleEmployeeChange}
                  />
                </div>
              </div>
            ) : (
              ""
            )}

            <div className="col-md-3">
              <div className="col-auto">
                <label>
                  <b></b>
                </label>
              </div>
              <div className="col-auto">
                <button className="custom-btn" onClick={fetchFormTemplate}>
                  Get Data
                </button>
              </div>
            </div>
          </div>

          {pageLaoding ? (
            <>
              <p className="position-absolute top-50 start-50 translate-middle text-center">
                <FaSpinner className="spinner" />
              </p>
            </>
          ) : (
            <>
              <div id="myTabContent" className="row mt-3">
                {employeData && (
                  <div>
                    <h3>
                      {employeData.EmployeeName}
                      <span className="fs-5"> ({employeData.Designation})</span>
                    </h3>
                    <div className="d-flex gap-5">
                      {employeData.JoiningDate && (
                        <p>
                          <strong>Joining Date:</strong>{" "}
                          {moment(employeData.JoiningDate).format(
                            "DD-MMM-YYYY"
                          )}
                        </p>
                      )}
                      <p>
                        <strong>Evaluation Date:</strong>{" "}
                        {moment().format("DD-MMM-YYYY")}
                      </p>
                      <p>
                        <strong>Reviewer:</strong> {employeData.ReviewerName}
                      </p>
                    </div>
                  </div>
                )}
              </div>

              <div className="row mt-2">
                {formCount === 1 && (
                  <div className="col-md-12">
                    <div className="box-body table-responsive container-fluid px-2">
                      <button
                        type="button"
                        className="scroll-btn scroll-to-bottom"
                        onClick={() => {
                          const el = document.getElementById("forJumptoUp");
                          if (el) el.scrollIntoView({ behavior: "smooth" });
                        }}
                        style={{
                          position: "fixed",
                          top: "70px",
                          right: "15px",
                          zIndex: "1000",
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          backgroundColor: "#27568B",
                          color: "white",
                          border: "none",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                          transition: "all 0.3s ease",
                          fontSize: "20px",
                        }}
                      >
                        <i className="bi bi-arrow-down fs-6"></i>
                      </button>
                      <form onSubmit={handleEmployeeSubmit}>
                        {formVisible && (
                          <Table striped bordered>
                            <thead id="thcolor" className="text-center">
                              <tr>
                                <th>#</th>
                                <th>Employee Response</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formTemplate.map((question, index) => (
                                <tr
                                  id="myTabContent"
                                  key={question.QuestionMasterID}
                                  data-question-id={question.QuestionMasterID}
                                >
                                  <td className="text-center">{index + 1}</td>
                                  <td>
                                    <h6>
                                      <b>{question.question_title}</b>
                                    </h6>
                                    {question.QuestionType_202 === 1342 ? (
                                      <>
                                        <textarea
                                          className="form-control w-100"
                                          onChange={(e) =>
                                            handleTextChange(
                                              e,
                                              question.QuestionMasterID,
                                              question
                                            )
                                          }
                                          value={
                                            formData[question.QuestionMasterID]
                                              ?.answer || ""
                                          }
                                        />
                                        {errorMessages[
                                          question.QuestionMasterID
                                        ] && (
                                          <small className="error">
                                            {
                                              errorMessages[
                                                question.QuestionMasterID
                                              ]
                                            }
                                          </small>
                                        )}
                                        <div className="col-2 mt-2">
                                          <div className="col-2 mt-2">
                                            <input
                                              type="number"
                                              min="0"
                                              max={
                                                question?.Weightage || "10.00"
                                              }
                                              step="0.01"
                                              placeholder={`Out Of ${
                                                question?.Weightage || "10.00"
                                              }`}
                                              value={
                                                formData[
                                                  question.QuestionMasterID
                                                ]?.EmployeeRating || null
                                              }
                                              className="form-control-sm Ques_input"
                                              onFocus={(e) => e.target.select()}
                                              onChange={(e) =>
                                                handleTextRatingChange(
                                                  e,
                                                  question.QuestionMasterID,
                                                  question
                                                )
                                              }
                                              onWheel={(e) => e.target.blur()}
                                            />
                                          </div>{" "}
                                          {errorMessages[
                                            `${question.QuestionMasterID}_rating`
                                          ] && (
                                            <small className="error d-block mt-1">
                                              {
                                                errorMessages[
                                                  `${question.QuestionMasterID}_rating`
                                                ]
                                              }
                                            </small>
                                          )}
                                        </div>
                                      </>
                                    ) : question.QuestionType_202 === 1343 ? (
                                      <div className="px-1">
                                        {[
                                          {
                                            key: "Option1",
                                            option: question.Option1,
                                            weightage:
                                              question.OptionWeightage1,
                                          },
                                          {
                                            key: "Option2",
                                            option: question.Option2,
                                            weightage:
                                              question.OptionWeightage2,
                                          },
                                          {
                                            key: "Option3",
                                            option: question.Option3,
                                            weightage:
                                              question.OptionWeightage3,
                                          },
                                          {
                                            key: "Option4",
                                            option: question.Option4,
                                            weightage:
                                              question.OptionWeightage4,
                                          },
                                        ].map(
                                          (item, idx) =>
                                            item.option && (
                                              <div
                                                key={idx}
                                                className="form-check"
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type="radio"
                                                  name={`question-${question.QuestionMasterID}`}
                                                  value={item.weightage}
                                                  onChange={(e) =>
                                                    handleRadioChange(
                                                      e,
                                                      question.QuestionMasterID,
                                                      item.key,
                                                      item
                                                    )
                                                  }
                                                  checked={
                                                    formData[
                                                      question.QuestionMasterID
                                                    ]?.selectedOption ===
                                                    item.key
                                                  }
                                                />
                                                <label className="form-check-label">
                                                  {item.option}
                                                </label>
                                              </div>
                                            )
                                        )}

                                        {errorMessages[
                                          question.QuestionMasterID
                                        ] && (
                                          <div className="error mt-2">
                                            {
                                              errorMessages[
                                                question.QuestionMasterID
                                              ]
                                            }
                                          </div>
                                        )}
                                      </div>
                                    ) : question.QuestionType_202 === 1347 ? (
                                      <div className="px-1">
                                        {question.Option1 && (
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              value={question.OptionWeightage1}
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  e,
                                                  question.QuestionMasterID,
                                                  "Option1",
                                                  question.Option1,
                                                  question.OptionWeightage1,
                                                  question
                                                )
                                              }
                                              checked={
                                                formData[
                                                  question.QuestionMasterID
                                                ]?.selectedOptions?.includes(
                                                  "Option1"
                                                ) || false
                                              }
                                            />
                                            <label className="form-check-label">
                                              {question.Option1}
                                            </label>
                                          </div>
                                        )}

                                        {question.Option2 && (
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              value={question.OptionWeightage2}
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  e,
                                                  question.QuestionMasterID,
                                                  "Option2",
                                                  question.Option2,
                                                  question.OptionWeightage2,
                                                  question
                                                )
                                              }
                                              checked={
                                                formData[
                                                  question.QuestionMasterID
                                                ]?.selectedOptions?.includes(
                                                  "Option2"
                                                ) || false
                                              }
                                            />
                                            <label className="form-check-label">
                                              {question.Option2}
                                            </label>
                                          </div>
                                        )}

                                        {question.Option3 && (
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              value={question.OptionWeightage3}
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  e,
                                                  question.QuestionMasterID,
                                                  "Option3",
                                                  question.Option3,
                                                  question.OptionWeightage3,
                                                  question
                                                )
                                              }
                                              checked={
                                                formData[
                                                  question.QuestionMasterID
                                                ]?.selectedOptions?.includes(
                                                  "Option3"
                                                ) || false
                                              }
                                            />
                                            <label className="form-check-label">
                                              {question.Option3}
                                            </label>
                                          </div>
                                        )}

                                        {question.Option4 && (
                                          <div className="form-check">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              value={question.OptionWeightage4}
                                              onChange={(e) =>
                                                handleCheckboxChange(
                                                  e,
                                                  question.QuestionMasterID,
                                                  "Option4",
                                                  question.Option4,
                                                  question.OptionWeightage4,
                                                  question
                                                )
                                              }
                                              checked={
                                                formData[
                                                  question.QuestionMasterID
                                                ]?.selectedOptions?.includes(
                                                  "Option4"
                                                ) || false
                                              }
                                            />
                                            <label className="form-check-label">
                                              {question.Option4}
                                            </label>
                                          </div>
                                        )}

                                        {errorMessages[
                                          question.QuestionMasterID
                                        ] && (
                                          <div className="error mt-2">
                                            {
                                              errorMessages[
                                                question.QuestionMasterID
                                              ]
                                            }
                                          </div>
                                        )}
                                      </div>
                                    ) : null}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        )}

                        {formVisible && (
                          <div id="forJumptoUp" className="mt-3 text-end">
                            <button
                              type="button"
                              className="cancel-btn me-2"
                              onClick={handleCancel}
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              disabled={loadingDraft ? true : false}
                              onClick={(e) => handleEmployeeSubmit(e, true)}
                              className="custom-btn me-2"
                            >
                              {loadingDraft ? (
                                <FaSpinner className="sm-spinner" />
                              ) : (
                                "Save As Draft"
                              )}
                            </button>

                            <button
                              type="submit"
                              disabled={loading ? true : false}
                              className="custom-btn me-2"
                            >
                              {loading ? (
                                <FaSpinner className="sm-spinner" />
                              ) : (
                                "Submit"
                              )}
                            </button>
                          </div>
                        )}
                      </form>
                      <button
                        type="button"
                        className="back-to-top-btn"
                        onClick={() => {
                          const el = document.getElementById("myTabContent");
                          if (el) el.scrollIntoView({ behavior: "smooth" });
                        }}
                        style={{
                          position: "fixed",
                          bottom: "40px",
                          right: "15px",
                          zIndex: 1000,
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                          backgroundColor: "#27568B",
                          color: "white",
                          border: "none",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                          transition: "all 0.3s ease",
                          fontSize: "20px",
                        }}
                      >
                        <i className="bi bi-arrow-up fs-6"></i>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
      {templateAPIStatus === 201 ? (
        <div
          style={{
            maxWidth: "400px",
            margin: "2rem auto",
            padding: "1.5rem",
            border: "1px solid #ddd",
            borderRadius: "0.5rem",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
            textAlign: "center",
            backgroundColor: "#fff",
          }}
        >
          <div
            style={{
              width: "64px",
              height: "64px",
              backgroundColor: "#FFE8D6",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 1rem",
            }}
          >
            <AlertCircle
              style={{ width: "32px", height: "32px", color: "#FF8C42" }}
            />
          </div>

          <h3
            style={{
              fontSize: "1.25rem",
              fontWeight: "600",
              color: "#dc5a5aff",
              marginBottom: "0.5rem",
            }}
          >
            {templateMessage}
          </h3>
        </div>
      ) : null}
    </>
  );
};

export default PerformanceEvaluations;